export const tachographConfirmOptions = {
  title: 'tachograph.txt.confirmation_title',
  message: 'tachograph.txt.confirmation_message'
}
